import { useEffect, useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { ChatPanel } from "@/components/AiDrawer";
import { api } from "@/lib/api";

export default function Copilot() {
  const [runs, setRuns] = useState([]);
  useEffect(() => { api.get("/ai/agent-runs").then((r) => setRuns(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="copilot-page">
      <PageHeader title="AI Copilot" subtitle="Grounded on your books. Every side-effecting action needs your approval." />
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="panel h-[62vh] lg:col-span-2">
          <ChatPanel />
        </div>
        <div className="panel" data-testid="agent-runs-panel">
          <div className="border-b border-border px-4 py-2.5">
            <h2 className="font-display text-sm font-bold">Agent runs</h2>
          </div>
          <div className="divide-y divide-border">
            {runs.map((r) => (
              <div key={r.id} className="p-3 text-xs" data-testid={`agent-run-${r.id}`}>
                <p className="flex items-center justify-between">
                  <span className="font-medium">{r.agent}</span>
                  <span className="bg-muted px-1.5 text-[10px] uppercase tracking-widest text-muted-foreground">{r.status}</span>
                </p>
                <p className="mt-1 line-clamp-2 text-muted-foreground">{r.input}</p>
                <p className="num mt-1 text-[10px] text-muted-foreground">{new Date(r.at).toLocaleString("en-IN")}</p>
              </div>
            ))}
            {runs.length === 0 && (
              <p className="p-4 text-xs text-muted-foreground">
                No agent runs yet. Try the command palette (⌘K) and type a transaction in plain language.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
